import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    subId = '',
    config = {},
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.orgGroupConfig.saveKpiConfig, {
        subId,
        config,
    }, options);
    if (error) return { error, status };
    return content || { };
};
